import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import AccountUserServer from 'resources/server/AccountUserServer';
import type { Memberships } from 'resources/types/GetUserSubscription';

import useGetUserSettingsQuery from './useGetUserSettingsQuery';

export const getMembershipsKey = 'memberships';

function useGetMemberships(options: UseQueryOptions<{ subscription: Memberships }> = { enabled: true }) {
  const { data: user } = useGetUserSettingsQuery();

  return useQuery({
    queryKey: [getMembershipsKey, user?.id],
    queryFn: async () => await AccountUserServer.getMemberships(),
    enabled: !!user?.id && !!options.enabled,
    retry: false,
    refetchOnWindowFocus: false,
  });
}

export default useGetMemberships;
